interface EmptyStateProps {
  icon: string;
  title: string;
  subtitle?: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
}

export default function EmptyState({
  icon,
  title,
  subtitle,
  ctaLabel,
  onCtaClick,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-[var(--sp-12)] px-[var(--sp-4)]">
      <i
        className={`icon ${icon}`}
        style={{
          fontSize: 48,
          color: 'var(--color-icon-neutral-medium)',
        }}
      />
      <h3
        className="mt-[var(--sp-4)] text-[16px] font-semibold text-center"
        style={{ color: 'var(--color-text-neutral-strong)' }}
      >
        {title}
      </h3>
      {subtitle && (
        <p
          className="mt-[var(--sp-2)] text-[14px] text-center max-w-[320px]"
          style={{ color: 'var(--color-text-neutral-subtle)' }}
        >
          {subtitle}
        </p>
      )}
      {ctaLabel && onCtaClick && (
        <button
          onClick={onCtaClick}
          className="mt-[var(--sp-6)] h-[44px] px-[var(--sp-4)] rounded-[var(--radius-md)] text-[14px] font-semibold text-white transition-colors duration-[120ms] cursor-pointer"
          style={{
            background: 'var(--color-surface-action-strong-default)',
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background =
              'var(--color-surface-action-strong-hover)')
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background =
              'var(--color-surface-action-strong-default)')
          }
        >
          {ctaLabel}
        </button>
      )}
    </div>
  );
}
